import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router-dom';
import { isAdminSelector } from '../../auth/selectors/authSelectors';
import { logOut } from '../../auth/actions/authActions';
import LogoutButton from '../components/LogoutButton/LogoutButton';

const mapStateToProps = createStructuredSelector({ isAdmin: isAdminSelector });
const mapDispatchToProps = { logOut };

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(LogoutButton)
);
